import React from "react";
import { Route, Redirect } from "react-router-dom";

//REDUX
import { useSelector } from "react-redux";

function PublicRoute({ component: Component, ...rest }) {
  const user = useSelector(state => state.user);

  return (
    <Route
      {...rest}
      render={props =>
        !user || !user.isLogged ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

export default PublicRoute;
